import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

const MetaHelmet = ({ meta_title, meta_description, keyword }) => {
  return (
    <Helmet>
      <title>{meta_title}</title>
      <meta name="description" content={meta_description + "- Nepal Travel Services"} />
      <meta name="author" content="Nepal Travel Services" />
      <meta name="keywords" content={keyword} />
      {/* You can add any other dynamic meta tags here */}
    </Helmet>
  );
};

MetaHelmet.propTypes = {
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
  keyword: PropTypes.string,
};

export default MetaHelmet;
